import EventBus from './event'

const GlobalEventBus = new EventBus('GlobalEventBus');

export { GlobalEventBus }